import { DatabaseShape } from './types';
import { initialDb } from './seed';

const STORAGE_KEY = process.env.REACT_APP_DB_KEY || 'car_rental_admin_db_v1';

export function readDatabase(): DatabaseShape {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(initialDb));
      return initialDb;
    }
    return JSON.parse(stored) as DatabaseShape;
  } catch (error) {
    console.warn('Failed to read from localStorage, using initial data:', error);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(initialDb));
    return initialDb;
  }
}

export function writeDatabase(db: DatabaseShape): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(db));
  } catch (error) {
    console.error('Failed to save to localStorage:', error);
  }
}
